define('helper-entity-isQuizTaskPage',['exports', './content--get-entity.es', './entity--is-parent-quiz-task-page.es'], function (exports, _contentGetEntity, _entityIsParentQuizTaskPage) {
    'use strict';

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    var _contentGetEntity2 = _interopRequireDefault(_contentGetEntity);

    var _entityIsParentQuizTaskPage2 = _interopRequireDefault(_entityIsParentQuizTaskPage);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    exports.default = function (ID, contentEntities) {

        if (!ID || typeof ID !== 'string') {
            return false;
        }

        var entity = (0, _contentGetEntity2.default)(ID, contentEntities);

        if (!entity) {
            return false;
        }

        return (0, _entityIsParentQuizTaskPage2.default)(entity.contentEntity.parentId, contentEntities);
    };
});
